import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { OemService } from './oem.service';
import { SasManagementChangePasswordSentComponent } from './sas-management-change-password-sent/sas-management-change-password-sent.component';
import { SasManagementForgotPasswordComponent } from './sas-management-forgot-password/sas-management-forgot-password.component';
import { SasManagementInputComponent } from './sas-management-input/sas-management-input.component';
import { SasManagementLoginComponent } from './sas-management-login/sas-management-login.component';
import { SasManagementOemHeaderComponent } from './sas-management-oem-header/sas-management-oem-header.component';
import { SasManagementOemLoginMessageComponent } from './sas-management-oem-login-message/sas-management-oem-login-message.component';
import { SasManagementOemRegisterMessageComponent } from './sas-management-oem-register-message/sas-management-oem-register-message.component';
import { SasManagementPasswordInputComponent } from './sas-management-password-input/sas-management-password-input.component';
import { SasManagementRegisterResendComponent } from './sas-management-register-resend/sas-management-register-resend.component';
import { SasManagementRegisterSendComponent } from './sas-management-register-send/sas-management-register-send.component';
import { SasManagementRegisterComponent } from './sas-management-register/sas-management-register.component';
import { SasManagementResetPasswordComponent } from './sas-management-reset-password/sas-management-reset-password.component';
import { SasManagementUnblockComponent } from './sas-management-unblock/sas-management-unblock.component';
import { SasManagementComponent } from './sas-management/sas-management.component';

@NgModule({
  declarations: [
    SasManagementComponent,
    SasManagementLoginComponent,
    SasManagementRegisterComponent,
    SasManagementUnblockComponent,
    SasManagementRegisterResendComponent,
    SasManagementRegisterSendComponent,
    SasManagementForgotPasswordComponent,
    SasManagementResetPasswordComponent,
    SasManagementChangePasswordSentComponent,
    SasManagementInputComponent,
    SasManagementPasswordInputComponent,
    SasManagementOemHeaderComponent,
    SasManagementOemRegisterMessageComponent,
    SasManagementOemLoginMessageComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    SasManagementResetPasswordComponent,
    SasManagementComponent,
    SasManagementRegisterResendComponent,
    SasManagementRegisterSendComponent,
    SasManagementUnblockComponent,
    SasManagementChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SasManagementModule {}
